import "./myPagesStyle.css"

import React, {Component} from "react";
import {Button} from "@material-ui/core";
import Divider from '@mui/material/Divider';
import Box from "@mui/material/Box";
import {
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import { DropzoneArea } from "mui-file-dropzone";






export default class MyPages extends Component{

    static defaultProps = {
        someState: false,
    };
    constructor(props) {
        super(props);

        this.state = {
            sessionActive: false,
            myAddsPage: false,
            addStep: 0,
        };

        this.myAddsPage = this.myAddsPage.bind(this);
        this.welcomePage = this.welcomePage.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleAddCreate = this.handleAddCreate.bind(this);

    }



    handleClick = (event) => {
        this.setState((prevState) => ({
            myAddsPage: !prevState.myAddsPage
        }));
    }

    handleAddCreate= () => {
        this.setState({ addStep: 1 });
    };


    myAddsFlowFeatures(){
        return(
            <div className="myPagesCreateAddFeaturesContainer">
                <FormControl
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center', // Aligns items vertically in the middle
                        width: '60%',
                        height: 'auto', // Set height to auto to avoid container collapsing
                    }}
                >
                    <Select required
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={0}
                            style={{width:'100%'}}
                            >
                                <MenuItem value={10}>Lägenhet</MenuItem>
                                <MenuItem value={20}>Villa</MenuItem>
                                <MenuItem value={20}>Radhus</MenuItem>
                                <MenuItem value={20}>Fritidsboende</MenuItem>
                                <MenuItem value={30}>Tomt</MenuItem>
                                <MenuItem value={30}>Gård</MenuItem>
                            </Select>

                        <TextField required={true}
                                   id="outlined-basic"
                                   variant="outlined"
                                   style={{width:'100%'}}
                                   placeholder="Fin 4a i Stockholms innerstad"
                        />
                    <div>
                        <FormControlLabel control={<Checkbox defaultUnchecked />} label="Balkong/Uteplats/Terass" />
                        <FormControlLabel control={<Checkbox defaultUnchecked />} label="Hiss" />
                    </div>

                    </FormControl>
                <Button variant="text"
                        color="success"
                        style={{ height: '60px', width:'20%'}}
                        onClick={this.handleAddCreate}
                        data-name="x">Gå Vidare</Button>
            </div>
        );
    }

    myAddsFlowFinance(){
        return(<></>);
    }
    myAddsFlowLocation(){

        return(
        <Box
            component="form"
            noValidate
            autoComplete="off"
        >
            <TextField id="outlined-basic" label="Outlined" variant="outlined" />
            <TextField id="standard-basic" label="Standard" variant="standard" />

            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Bostadstyp</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={0}
                    label="Bostadstyp"
                >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                </Select>
            </FormControl>

            <Button
                variant="contained"
                component="label"
            >
                Upload File
                <input
                    type="file"
                    hidden
                />
            </Button>

            <DropzoneArea/>
        </Box>
        );
    }

    myAddsPage(){

        return(
            <div className="myPagesContainer">
                <div className="myPagesCreateAddContainer">
                {this.state.addStep === 0 &&
                    <Button variant="text"
                            style={{color:'#384965', height: '60px', }}
                            onClick={this.handleAddCreate}
                            data-name="x">Skapa annons</Button>
                }

                {this.state.addStep === 1 && this.myAddsFlowFeatures()}
                {this.state.addStep === 2 && this.myAddsFlowLocation()}
                {this.state.addStep === 3 && this.myAddsFlowFinance()}

                </div>
            </div>
        );
    }

    welcomePage(){
        return(
            <div className="myPagesContainer">
                <p>Hej $user!</p>
            </div>
        );
    }

    renderMyPages()
    {

        return (
            <div className="myPagesContainer">
                <div className="myPagesContent">
                    <div className="menu">
                        <Divider/>
                        <Button variant="text" style={{color:'#384965', height: '60px'}} onClick={this.handleClick} data-name="x">Mina annonser</Button>
                        <Divider/>
                        <Button variant="text" style={{color:'#384965', height: '60px'}} onClick={this.handleClick} data-name="x">Mina övervakningar</Button>
                        <Divider/>
                        <Button variant="text" style={{color:'#384965', height: '60px'}} onClick={this.handleClick} data-name="x">x</Button>
                        <Divider/>
                        <Button variant="text" style={{color:'#384965', height: '60px'}} onClick={this.handleClick} data-name="x">Mina annonser</Button>
                        <Divider/>
                    </div>
                    <Divider orientation="vertical" flexItem />
                    <div className="mainBox">
                        {this.state.myAddsPage && this.myAddsPage()}
                    </div>
                </div>
            </div>
        );
    }

    render(){
        return(this.renderMyPages());
    }
};
